<template>
    <div>
    </div>
</template>

<script>
    export default {
        mounted: function () {
            this.logoutUser();
            this.$router.push({
                name: 'home'
            });
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/auth/Logout.vue